import React, { useState } from 'react';
import { Card, CardContent, Collapse, Typography } from '@material-ui/core';

import { ArrowRight, ArrowDropDown } from '@material-ui/icons';

import { Grid } from '@mui/material';
import useReactHookFormStyles from '../../form-components/ReactHookForm.styles';

const FormCollapseCard = ({ label, children, open = false }) => {
    const [showContent, setShowContent] = useState(open);
    const classes = useReactHookFormStyles();

    return (
        <Card variant="outlined" className={classes.collapseCard}>
            <CardContent className={classes.collapseCardHeaderText} onClick={() => setShowContent((curr) => !curr)}>
                <Grid container justifyContent="space-between">
                    <Typography>{label}</Typography>
                    {showContent ? <ArrowRight></ArrowRight> : <ArrowDropDown></ArrowDropDown>}
                </Grid>
            </CardContent>
            <Collapse in={showContent}>
                <CardContent>{children}</CardContent>
            </Collapse>
        </Card>
    );
};

export default FormCollapseCard;
